import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "store/apps/lang";
import { RootState } from "store";
import { useTranslation } from "react-i18next";

export default function useLanguageDropDown() {
  const { t, i18n } = useTranslation();

  const currentLanguage = useSelector((state: RootState) => state.lang.language);

  const dispatch = useDispatch();

  const _onSelectLanguage = (selectedLanguage: string) => {
    i18n.changeLanguage(selectedLanguage);
    dispatch(setLanguage(selectedLanguage));
  };

  return { currentLanguage, _onSelectLanguage };
}
